import { useTranslations } from 'next-intl';

import { Modal } from '@flipster/react/design-system-legacy/modal';
import { Button } from '@flipster/react/design-system/button';
import { css } from '@flipster/styled-system/css';

interface LossProtectModalProps {
  isOpen: boolean;
  onClose: () => void;
  onExit: () => void;
}

const LossProtectModal = ({ isOpen, onClose, onExit }: LossProtectModalProps) => {
  const transAssets = useTranslations('Assets.r250401');

  return (
    <Modal size='large' isOpen={isOpen} onExit={onExit}>
      <Modal.Close onClose={onClose} />
      <Modal.Header>
        <Modal.Title label={transAssets('Loss_protected')} />
      </Modal.Header>
      <Modal.Content>
        <p className={css({ textStyle: 'Text/L/Regular', color: 'content.default.level-3', pb: 16 })}>
          {transAssets('Loss_protected_description')}
        </p>
        <ul
          className={css({
            borderRadius: 8,
            bg: 'background.default.level-3',
            color: 'content.default.level-3',
            textStyle: 'Text/L/Regular',
            p: '16px 12px',
          })}
        >
          <li className={listStyle}>{transAssets('Verify_your_identity')}</li>
          <li className={listStyle}>{transAssets('Deposit_100_usdt_within_24_hours')}</li>
          <li className={listStyle}>
            {transAssets('Maintain_a_net_deposit_of_at_least_100_usdt_in_your_account_description')}
          </li>
          <li className={listStyle}>{transAssets('You_will_receive_back_up_to_20_description')}</li>
        </ul>
      </Modal.Content>
      <Modal.Footer>
        <Button hierarchy='primary' color='accent' size='medium' label={transAssets('Confirm')} onClick={onClose} />
      </Modal.Footer>
    </Modal>
  );
};

export default LossProtectModal;

const listStyle = css({
  position: 'relative',
  pl: 30,
  pb: 12,
  _before: {
    position: 'absolute',
    content: "''",
    top: '8px',
    bottom: '-12px',
    left: '10.5px',
    width: '1px',
    bg: 'border.default.level-3',
  },
  _after: {
    position: 'absolute',
    content: "''",
    top: '8px',
    left: '8px',
    width: '6px',
    height: '6px',
    bg: 'content.default.level-3',
    borderRadius: '50%',
  },
  _last: {
    pb: 0,
    _before: {
      bottom: 'unset',
    },
  },
});
